import dayjs, { Dayjs } from "utils/dayjs";
import { Guid } from "@/types";

export interface IGetCalculationDetailsVersionCommentDto{
    id:Guid
    userId:Guid
    date:string
    comment:string
}

export interface IPostCalculationDetailsVersionCommentDto{
    comment:string
}

export default class CalculationDetailsVersionComment{
    id:Guid
    userId:Guid
    date: Dayjs
    comment: string

    userEmail?: string

    constructor(dto: IGetCalculationDetailsVersionCommentDto){
        this.id= dto.id
        this.userId = dto.userId
        this.date = dayjs(dto.date)
        this.comment = dto.comment
    }

    provideUserEmail(userEmail:string){
        this.userEmail = userEmail
    }
}
